import React from 'react';
import classes from './NoDataFound.module.css';
import { IoSearch } from 'react-icons/io5';
import { Docs } from '../../../Constant';
import clsx from 'clsx';
export default function NoDataFound({ className, label = 'No Data Found' }) {
  return (
    <div className={clsx(classes.wrapper, className)}>
      <ul className={classes.card}>
        <li>
          <Docs />
        </li>
        <li>
          <h2 className={classes.title}>{label}</h2>
        </li>
      </ul>
    </div>
  );
}
